export const CHANGE_DRIVER_LIST = 'scenes/VehicleDetail/components/Drivers/DriverList/change_driver_list'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/constants.js